module.exports = require("ink-select-input");